// @mui
import { arSD, enUS, frFR, viVN, zhCN } from '@mui/material/locale';
// components
import { SettingsValueProps } from './components/settings/type';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_API_URL;

export const USE_LOCAL_APIS = process.env.REACT_APP_API_ENV === 'local';
export const LOCAL_API_URLS = {
  auth: process.env.REACT_APP_LOCAL_AUTH_API_URL || '',
  wallet: process.env.REACT_APP_LOCAL_WALLET_API_URL || '',
  pointsEngine: process.env.REACT_APP_LOCAL_POINTS_ENGINE_API_URL || '',
  benefits: process.env.REACT_APP_LOCAL_BENEFITS_API_URL || '',
  invoices: process.env.REACT_APP_LOCAL_INVOICES_API_URL || '',
  tiers: process.env.REACT_APP_LOCAL_TIERS_API_URL || '',
  missions: process.env.REACT_APP_LOCAL_MISSIONS_API_URL || '',
  analytics: process.env.REACT_APP_LOCAL_ANALYTICS_API_URL || '',
  achievements: process.env.REACT_APP_LOCAL_ACHIEVEMENTS_API_URL || '',
  partners: process.env.REACT_APP_LOCAL_PARTNERS_API_URL || '',
};

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'blue',
  themeStretch: false,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'Vietnamese',
    value: 'vn',
    systemValue: viVN,
    icon: '/assets/icons/flags/ic_flag_vn.svg',
  },
  {
    label: 'Chinese',
    value: 'cn',
    systemValue: zhCN,
    icon: '/assets/icons/flags/ic_flag_cn.svg',
  },
  {
    label: 'Arabic (Sudan)',
    value: 'ar',
    systemValue: arSD,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
];

export const defaultLang = allLangs[0]; // English
